import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { ChallengeFormData } from '../types';
import FormPictureSelector from '../../../components/FormPictureSelector/FormPictureSelector';

interface BackgroundImageStepProps {
  control: Control<ChallengeFormData>;
  errors: FieldErrors<ChallengeFormData>;
}

const BackgroundImageStep = ({ control, errors }: BackgroundImageStepProps) => {
  // FIXME: Add the correct category ID for challenges images after we upload the assets and create them on every environment.
  const challengesImageCategories = ['596fb8dd28426e5206c20bed'];

  return (
    <div>
      <FormPictureSelector
        control={control}
        name="backgroundImage"
        labelText="Choose a background image for your challenge"
        errors={errors}
        selectMultiple={false}
        categories={challengesImageCategories}
        enableFileUpload={false}
        required={true}
      />
    </div>
  );
};

export default BackgroundImageStep;
